import React from "react";
import { Container } from "react-bootstrap";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import { PrismicRichText } from "@prismicio/react";

const History = ({ data }) => {
  return (
    <section className={`section-center ${s.history}`}>
      <Container>
        <div className={s.grid_wrapper}>
          <div className={s.grid}>
            <div className={s.desc_container}>
              <h2 className="title fw-bold">{data?.title}</h2>
              <div className={`${secondaryFont} ${s.desc}`}>
                <PrismicRichText field={data?.desc || []} />
              </div>
              {/* <Link href="" className="btn btn-outline-dark">
                Read More <IoArrowForward size="18px" style={{marginLeft: "8px"}} />
              </Link> */}
            </div>
            <div className={s.image_container}>
              <img
                loading="lazy"
                src={data?.img_1?.url}
                alt={data?.img_1?.alt || "image"}
                height="100%"
              />
            </div>
          </div>
          <div className={s.grid}>
            <div className={s.desc_container}>
              <div className={`${secondaryFont} ${s.desc}`}>
                <PrismicRichText field={data?.desc_2 || []} />
              </div>
            </div>
            <div className={s.image_container}>
              <img
                loading="lazy"
                src={data?.img_2?.url}
                alt={data?.img_2?.alt || "image"}
                height="100%"
              />
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default History;
